import i18next from "i18n.js";

import en from "./en.js";
import fr from "./fr.js";

i18next.addResourceBundle("en", "common", en);
i18next.addResourceBundle("fr", "common", fr);
